import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { T } from "../../../../../../../_ovlclient/src/global/globals"

export class CompOrderDetailLayout extends SYSBaseElement {
  async getUI() {
    let key = this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder
    let generalData
    if (
      this.state.app.screens.DATOrder.orderDetail.orders[key].orderType ===
      "own"
    ) {
      generalData = html`
        <section class="fd-section  fd-has-type-1" style="text-align: center;">
          ${T("DATDocumentDataOrderFilesTitle")}
        </section>

        <div class="fd-layout-panel">
          <div class="fd-layout-panel__body">
            <comp-filelist
              .props=${(s) => {
                return {
                  fileList: s.app.screens.DATOrder.orderDetail.orders[
                    key
                  ].attachments.files.filter(
                    (f) => f.type === "OrderAttachment"
                  ),
                }
              }}
            ></comp-filelist>
          </div>
        </div>
      `
    }

    return html`
      <div class="ovl-smart-padding-lr-symmetrical ovl-smart-screen-margins">
      <section
          class="fd-section fd-has-type-2" style="text-align: center;"
          <h3
            class="sap-icon--sales-order sap-icon--xl fd-layout-panel__title"
          >
            ${T("DATDocumentDataOrderDetail", [key])}
          </h3>
      </section>
        <div class="orderdetailsgrid">
          
            <comp-orderdetail></comp-orderdetail>
          

          
            <comp-orderfeedback></comp-orderfeedback>
          
        </div>
        <section
          class="fd-section fd-has-type-1"
          style="text-align: center;"
        >
          ${T("DATDocumentDataOrderTimelineTitle")}
        </section>
        <comp-ordertimeline></comp-ordertimeline>
        ${generalData}
      </div>
    `
  }
}
